import React, {Component} from "react";
import {Link} from "react-router";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import "./Connections.css";
import AppIntegrations from "../img/team_apps.png";
import BuildButton from "../img/build_button.png";
import WhatBuild from "../img/what_build.png";
import CustomIntegration from "../img/custom_integration.png";
import NewBot from "../img/new_bot.png";
import BotToken from "../img/bot_token.png";

class Connections extends Component {
    constructor() {
        super();
        this.state = {teamName: ''};

        this.onChangeTeamName = this.onChangeTeamName.bind(this)
    }

    onChangeTeamName(e) {
        this.setState({teamName: e.target.value});
    }

    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">About Connections</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>The <Link to="/bot/connections">Connections</Link> section controls how your bot connects to your services.</p>
                                <p>This section will help you set up your <i>Slack</i> settings, before setting up your other services.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h3>What you need</h3>
                                <p>
                                    You need to have a <Link href="https://www.slack.com">Slack</Link> account.
                                </p>

                                <h3>Add bot to your Slack team</h3>
                                <p>
                                    You can add a bot to your Slack team from the <i>Apps and integrations</i> section.
                                </p>

                                {/* Shortcut tip */}
                                <div className="alert alert-info hidden-xs">
                                    <h4>
                                        <strong>Shortcut</strong>
                                    </h4>
                                    <div>
                                        You can use this URL to get quickly to the bot configuration
                                        screen in Slack:
                                    </div>
                                    <div className="form-group m-t-sm">
                                        <label htmlFor="teamName">Enter your existing Slack team name:</label>
                                        <div className="input-group">
                                            <span className="input-group-addon">https://</span>
                                            <input type="text" className="form-control" name="teamName" placeholder="your-team-name"
                                                   onChange={this.onChangeTeamName}/>

                                            <span className="input-group-addon">.slack.com/apps/build/custom-integration</span>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <button disabled={this.state.teamName.trim().length > 0 ? '' : 'disabled'}
                                                onClick={() => document.location.href = `https://${this.state.teamName.trim()}.slack.com/apps/build/custom-integration`}
                                                className="btn btn-default" type="button">Take me to Slack!
                                        </button>
                                    </div>
                                    <div>
                                        Once you've done this, you can <Link href="#custom-integration">skip to step 4</Link>.
                                    </div>
                                </div>

                                {/* Step 1 */}
                                <h4 className="step">Step 1: View Apps and Integrations</h4>
                                <p>
                                    Open the <strong>Apps &amp; integrations</strong> section from the drop-down menu for your team:
                                </p>
                                <img src={AppIntegrations} style={{width: 284}} className="step" alt="Apps and integrations"/>

                                {/* Step 2 */}
                                <h4 className="step">Step 2: Click the <i>Build</i> button</h4>
                                <p>
                                    Click the <strong>Build</strong> button in the top navigation bar.
                                </p>
                                <img src={BuildButton} style={{width: 411}} className="step" alt="Build button"/>

                                {/* Step 3 */}
                                <h4 className="step">Step 3: Something just for your team</h4>
                                <p>
                                    Click the <strong>Make a Custom Integration</strong> button in the 'Something just for my team'
                                    box.
                                </p>
                                <img src={WhatBuild} style={{width: 487}} className="step" alt="Make a Custom Integration"/>

                                {/* Step 4 */}
                                <h4 id="custom-integration" className="step">Step 4: Bots</h4>
                                <p>
                                    Click the <strong>Bots</strong> item in the list.
                                </p>
                                <img src={CustomIntegration} style={{width: 708}} className="step" alt="Bots"/>

                                {/* Step 5 */}
                                <h4 id="custom-integration" className="step">Step 5: Bot name</h4>
                                <p>
                                    Name your bot. This will be how you refer to your bot in your chats.
                                    For example: <strong>@cloudMocks</strong>
                                </p>
                                <img src={NewBot} style={{width: 971}} className="step" alt="Bot name"/>

                                {/* Step 6 */}
                                <h4 id="custom-integration" className="step">Step 6: Token</h4>
                                <p>
                                    Make a note of your <strong>Token</strong>. This is what you need to enter
                                    in the <Link to="/bot/connections">Connections</Link> screen.
                                </p>
                                <img src={BotToken} style={{width: 1003}} className="step" alt="Slack token"/>

                                {/* Conclusion */}
                                <h4 id="custom-integration" className="step">You're done!</h4>
                                <p>
                                    Once you've updated the <Link to="/bot/connections">Connections</Link> screen,
                                    you're all set to talk to your bot.
                                </p>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Connections;



// WEBPACK FOOTER //
// ./src/modules/views/docs/bot/Connections.js